export const clusterLayer = {
  id: "clusters",
  type: "circle",
  source: "dynamic-map-geojson",
  filter: ["has", "point_count"],
  paint: {
    "circle-color": [
      "case",
      ["boolean", ["feature-state", "hover"], false],
      "hsla(0, 0%, 0%, 0.5)",
      "#000",
    ],
    "circle-color-transition": { duration: 400 },

    // "circle-color": [
    //   "step",
    //   ["get", "point_count"],
    //   "#000",
    //   100,
    //   "#000",
    //   750,
    //   "#000",
    // ],
    // "circle-radius": ["step", ["get", "point_count"], 20, 100, 30, 750, 40],
    "circle-radius": [
      "case",
      ["boolean", ["feature-state", "hover"], false],
      25,
      15,
    ],
    "circle-radius-transition": { duration: 400 },
  },
};

export const clusterCountLayer = {
  id: "cluster-count",
  type: "symbol",
  source: "dynamic-map-geojson",
  filter: ["has", "point_count"],
  paint: {
    "text-color": "#ffffff",
  },
  layout: {
    "text-field": "{point_count_abbreviated}",
    "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
    "text-size": 16,
  },
};

export const unclusteredPointLayer = {
  id: "unclustered-point",
  type: "circle",
  source: "dynamic-map-geojson",
  filter: ["!", ["has", "point_count"]],
  paint: {
    "circle-color": "#000",
    "circle-radius": 1,
    "circle-stroke-width": 1,
    "circle-stroke-color": "#fff",
  },
};
